import React from 'react';
import { Modal } from 'antd';
import { onGet, api } from '../../core/api3';
import 'antd-mobile/dist/antd-mobile.css';
import { dispatch } from '../../App';


class LoginMobileModal extends React.Component {


    constructor() {
        super();
        this.getUuid = this.getUuid.bind(this);
    }

    getUuid() {
        var s = [];
        var hexDigits = "0123456789abcdef";
        for (var i = 0; i < 36; i++) {
            s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
        }
        s[14] = "4";
        s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
        s[8] = s[13] = s[18] = s[23] = "-";
        var uuid = s.join("").replace(/-/g, "");
        return uuid;
    }

    componentDidMount() {
        let sessionId = localStorage.getItem('sessionId');
        if (!sessionId) {
            sessionId = this.getUuid();
            localStorage.setItem('sessionId', sessionId);
        }
        onGet(api.getAppToken.url, api.getAppToken.params(sessionId)).then(response => {
            if (response === undefined) {
                let redirectUrl = api.loginDing.url + '?sessionId=' + sessionId + '&url=' + encodeURIComponent(window.location.href);
                window.location.href = redirectUrl;
                return;
            }
            localStorage.setItem('token', response);
            dispatch.common.isLogin(true);
            window.location.reload();
        });
    }

    render() {
        return (
            <Modal title="登录" visible={false} okText="确定" />
        );
    }

}

export default LoginMobileModal;


// WEBPACK FOOTER //
// ./src/page/mobile/LoginMobileModal.jsx